/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SocialContextEntityType } from './socialContextEntityType';
import { UserRelationToGroup } from './userRelationToGroup';

export interface SocialContext { 
    entity_type: SocialContextEntityType;
    entity_id: string;
    entity_title: string;
    actor_role: UserRelationToGroup;
}